<template>
  <div class="relative" :class="SSectionVerticalMarginClasses">
    <TContainer :mobile-full="mobileFull" :desktop-full="desktopFull">
      <TGrid>
        <div
          class="col-span-12"
          :class="{
            'lg:col-span-8': !fullWidth,
            'lg:col-start-3': !fullWidth && centered,
          }"
        >
          <TSeparator
            v-if="hasSeparator"
            :class="SSectionSeparatorMarginClasses"
          />

          <TTitle
            v-if="title && title.length > 0"
            :tag="titleTag"
            :size="SSectionTitleSize"
            :class="{ 'text-center': centered }"
            :classes="SSectionTitleClasses"
            :leading="SSectionTitleLeading"
          >
            {{ title }}
          </TTitle>

          <slot />
        </div>
      </TGrid>
    </TContainer>

    <slot name="no-container" />
  </div>
</template>

<script setup lang="ts">
import type { SSectionTitleTagProp } from './constants'
import {
  SSectionVerticalMarginClasses,
  SSectionSeparatorMarginClasses,
  SSectionTitleTag,
  SSectionTitleSize,
  SSectionTitleClasses,
  SSectionTitleLeading,
} from './constants'

export interface propsInterface {
  title?: string
  titleTag?: SSectionTitleTagProp
  hasSeparator?: boolean
  fullWidth?: boolean
  mobileFull?: boolean
  desktopFull?: boolean
  centered?: boolean
}

withDefaults(defineProps<propsInterface>(), {
  titleTag: SSectionTitleTag,
  hasSeparator: true,
  fullWidth: true,
  mobileFull: false,
  desktopFull: false,
  centered: false,
})
</script>
